/**
 * 短網址彈窗模式
 */
export const ShorterDialogMode = {
  /** 個別建立 */
  SINGLE_CREATE: 'single-create',
  /** 個別編輯 */
  SINGLE_EDIT: 'single-edit',
  /** 建立副本 */
  SINGLE_COPY: 'single-copy',
  /** 群組建立 */
  GROUP_CREATE: 'group-create',
  /** 群組編輯 */
  GROUP_EDIT: 'group-edit',
  /** 群組內個別建立 */
  SINGLE_CREATE_IN_GROUP: 'single-create-in-group',
  /** 群組內個別編輯 */
  SINGLE_EDIT_IN_GROUP: 'single-edit-in-group',
  /** 群組內建立副本 */
  SINGLE_COPY_IN_GROUP: 'single-copy-in-group'
} as const

export type ShorterDialogMode = (typeof ShorterDialogMode)[keyof typeof ShorterDialogMode]

/**
 * 短網址彈窗設定
 */
export interface ShorterDialogConfig {
  title: string
  defaultBtnText: string
  loadingBtnText: string
}

export const SHORTER_DIALOG_CONFIG: Record<ShorterDialogMode, ShorterDialogConfig> = {
  [ShorterDialogMode.SINGLE_CREATE]: {
    title: '建立短網址',
    defaultBtnText: '確認',
    loadingBtnText: '建立中...'
  },
  [ShorterDialogMode.SINGLE_EDIT]: {
    title: '編輯短網址',
    defaultBtnText: '確認',
    loadingBtnText: '儲存中...'
  },
  [ShorterDialogMode.SINGLE_COPY]: {
    title: '建立副本',
    defaultBtnText: '確認',
    loadingBtnText: '建立中...'
  },
  [ShorterDialogMode.GROUP_CREATE]: {
    title: '建立短網址',
    defaultBtnText: '確認',
    loadingBtnText: '建立中...'
  },
  [ShorterDialogMode.GROUP_EDIT]: {
    title: '編輯群組短網址',
    defaultBtnText: '確認',
    loadingBtnText: '儲存中...'
  },
  [ShorterDialogMode.SINGLE_CREATE_IN_GROUP]: {
    title: '個別新增',
    defaultBtnText: '確認',
    loadingBtnText: '建立中...'
  },
  [ShorterDialogMode.SINGLE_EDIT_IN_GROUP]: {
    title: '編輯短網址',
    defaultBtnText: '確認',
    loadingBtnText: '儲存中...'
  },
  [ShorterDialogMode.SINGLE_COPY_IN_GROUP]: {
    title: '建立個別副本',
    defaultBtnText: '確認',
    loadingBtnText: '建立中...'
  }
} as const

export const DELETE_CONFIRM_CONFIG = {
  /** 單一短網址刪除 */
  SINGLE_URL: {
    title: '永久刪除短網址',
    text: '您即將永久刪除該短網址。此操作無法復原。',
    confirmButtonText: '刪除'
  },
  /** 批量短網址刪除 */
  MULTIPLE_URLS: {
    title: '永久刪除選取的短網址',
    text: '您即將永久刪除選取的短網址。此操作無法復原。',
    confirmButtonText: '刪除'
  },
  /** 單一群組刪除 */
  SINGLE_GROUP: {
    title: '永久刪除群組',
    text: '您即將永久刪除該群組。此操作無法復原。',
    confirmButtonText: '刪除'
  },
  /** 批量群組刪除 (需動態傳入數量) */
  MULTIPLE_GROUPS: {
    title: '永久刪除選取的群組',
    text: '您即將永久刪除選取的群組。此操作無法復原。',
    confirmButtonText: '刪除'
  }
} as const

/**
 * 群組刪除類型
 */
export const GROUP_URL_DELETE_TYPE = {
  /** 單一群組*/
  SINGLE: 'single',
  /** 批量群組 */
  MULTIPLE: 'multiple'
}

export type GroupUrlDeleteType = (typeof GROUP_URL_DELETE_TYPE)[keyof typeof GROUP_URL_DELETE_TYPE]
